import type { WidgetSessionState } from '../../../types/appState';
import type { TRootState } from '../reducers';

export const selectWidgetSession = ({ widgetSession }: TRootState): WidgetSessionState => widgetSession;

export const selectWidgetSessionId = ({ widgetSession }: TRootState): string | undefined => {
  return widgetSession.sessionId;
};

export const selectWidgetSessionTabId = ({ widgetSession }: TRootState): string => {
  return widgetSession.sessionTabId;
};

export const selectIsSessionExpired = ({ widgetSession }: TRootState): boolean => {
  return widgetSession.isSessionExpired;
};
